export default "__VITE_ASSET__80fa5b01__"